export const SIGNATURE_CANCELED = window.jQuery ? $.__('Canceled') : 'Canceled';
export const SIGNATURE_PENDING = window.jQuery ? $.__('Signers Pending') : 'Signers Pending';
export const SIGNATURE_REQUIRED = window.jQuery ? $.__('Sign Now') : 'Sign Now';
export const SIGNATURE_SIGNED = window.jQuery ? $.__('Signed') : 'Signed';
export const NO_SIGNATURE_NEEDED = window.jQuery ? $.__('No Signature Needed') : 'No Signature Needed';
export const SIGNATURE_DECLINED = window.jQuery ? $.__('Chose Not to Sign') : 'Chose Not to Sign';
export const VIRUS_DETECTED = window.jQuery ? $.__('Virus Detected') : 'Virus Detected';
